import React from 'react';
import PropTypes from 'prop-types';
import { SanitizeHtml, Image } from '@bd/bdcore-utilities';
import { get } from 'lodash';

const SitePlan = ({ community }) => {
  return (
    <div className="container Community_overview" id="sitePlan">
      {
        get(community, 'lotvue_embed_code') &&
        <div className="embed-responsive embed-responsive-4by3">
          <div dangerouslySetInnerHTML={SanitizeHtml(get(community, 'lotvue_embed_code'))} />
        </div>
      }
      {
        !get(community, 'lotvue_embed_code') &&
        get(community, 'sitePlan.contentUrl') &&
        <div className="row">
          <div className="col-lg-8 mx-lg-auto">
            <Image
              src={get(community, 'sitePlan.contentUrl')}
              alt={get(community, 'name')}
              width={1600}
              height={1600}
              className="w-100"
            />
          </div>
        </div>
      }
    </div>
  );
};

SitePlan.propTypes = {
  community: PropTypes.object.isRequired,
};

export default SitePlan;



// WEBPACK FOOTER //
// ./src/pages/CommunityDetail/SitePlan.js